import { Customer } from "./customer.model";

export class AgencyClientsRecord {
	agencyId: string | undefined;
	clients: Customer[] | undefined;
}
